import React from 'react'
import { useNavigate } from 'react-router-dom'

function Footer() {
    const navigate = useNavigate()
    return (
        <div>
            <div className='lg:grid lg:grid-cols-12 bg-[#D6EAF8] rounded-[24px] px-[20px] py-[40px] mb-6'>
                <div className='col-span-6 flex justify-center items-center'>
                    <h1 className='xl:text-[80px] lg:text-[60px] md:text-[80px] text-[40px] text-[#236592] font-extrabold'>MR.HOUSING INDIA</h1>
                </div>
                <div className='col-span-6'>
                    <p className='md:text-[18px] text-[12px] font-normal'>Disclaimer : This website is not an official site. We are an authorized marketing partner
                         {/* [Finwizz Holdings RERA No – A51800018907] */}
                          for this project. Provided content is given by respective owners and this website and content is for information purposes only and it does not constitute any offer to avail for any services. Prices mentioned are subject to change without prior notice and properties mentioned are subject to availability. You can expect a call, SMS, or email on details registered with us.
                    </p>

                    <div className='mt-[25px] md:text-[18px] text-[12px]'>
                        <p className="text-center font-normal">
                            <span className="underline cursor-pointer" onClick={() => navigate("/privacypolicy")}>Privacy Policy </span> |
                            <span className="underline cursor-pointer" onClick={() => navigate("/termsandconditions")}> Terms & Conditions </span> |
                            <span className="underline cursor-pointer" > Cookie Policy </span>
                        </p>
                        {/* <p className='text-center font-normal mt-2'>Agent RERA No – A51800018907</p> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer